// extracted by mini-css-extract-plugin
export default {"wrap":"EditNotes_wrap__Po4zt","icon":"EditNotes_icon__zrKTB"};